// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"ebd38a9a","72":"b59505ba","189":"662311ca","238":"cc117883","294":"62ebae50","307":"a42e05f1","312":"72fc52da","375":"141f4741","539":"7b917b26","774":"b22b5c22","779":"cda5a131","975":"595b85ed"}[chunkId] + ".chunk.js";
};